import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);

type AnyDate = string | number | Date | dayjs.Dayjs;

export const getToday = () => dayjs();
export const getTomorrow = () => dayjs().add(1, 'day');
export const getNextYear = () => dayjs().add(1, 'year');
export const isTodayDate = (date: AnyDate) => dayjs(date).isToday();
export const getTimestamp = (date?: AnyDate) => dayjs(date ?? dayjs()).valueOf();
export const isPastDate = (date: AnyDate) =>
  dayjs(date).isBefore(dayjs(), 'day');
export const isTodayOrPastDate = (date: AnyDate) =>
  dayjs(date).isSameOrBefore(dayjs(), 'day');
export const getDaysDifference = (start: AnyDate, end: AnyDate) =>
  dayjs(start).diff(dayjs(end), 'day');

export default {
  getToday,
  getTomorrow,
  getNextYear,
  getDaysDifference,
  isTodayDate,
  isPastDate,
  isTodayOrPastDate,
  getTimestamp,
};
